(() => {
	if (!customElements.get('product-media-grid')) {
		class ProductMediaGrid extends HTMLElement {
			constructor() {
				super();

				this.mainMediaId = this.getAttribute('id');
			}

			connectedCallback() {
				this.attachEventListeners();
			}

			attachEventListeners() {
				// Pause all media when the window is resized
				window.addEventListener('resize', this.handleResize);
			}

			handleResize() {
				/* ===== Pause all media when the window is resized ===== */
				window.eventBus.emit('pause:media');
			}
		}

		customElements.define('product-media-grid', ProductMediaGrid);
	}
})();
